module.exports = __webpack_public_path__ + "static/hero-ee5e907a99b69a90ab8fa006b3a5607a.jpg";